// Vendors
import $ from 'jquery';
import NoSleep from 'nosleep.js';

$(document).ready(() => {
  if (!$('#cook-mode').length) {
    return;
  }
  const $cookMode = $('#cook-mode input[type="checkbox"]');
  $cookMode.on('change', () => {
    toogleCookMode();
  });
});

function toogleCookMode() {
  const $cookMode = $('#cook-mode input[type="checkbox"]');
  const noSleep = new NoSleep();
  if ($cookMode.prop('checked')) {
    noSleep.enable();
  } else {
    noSleep.disable();
  }
}
